import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'

const NACHStageModalUI = ({
  context,
  isOpen,
  mandate,
  targetStage,
  umrn,
  onUmrnChange,
  date,
  onDateChange,
  onSubmit,
  onCancel,
  errorList,
  setErrorList,
  successMsg,
  busy
}) => {
  if (!isOpen || !mandate) return null

  const isRegister = targetStage === 'registered'
  const title = isRegister
    ? `Register Mandate - ${mandate.urn}`
    : `Cancel Mandate - ${mandate.urn}`
  const buttonLabel = isRegister ? 'Register' : 'Confirm Cancellation'

  return (
    <ModalFormUI
      context={context}
      titleLabel={title}
      buttonLabel={buttonLabel}
      cancelLabel='Cancel'
      isOpen={isOpen}
      onRequestClose={onCancel}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={busy}
    >
      {isRegister && (
        <InputTextSF
          name='umrn'
          label='UMRN'
          required
          value={umrn}
          onChange={(e) => {
            const val = (e.target.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20)
            onUmrnChange(val)
          }}
          placeholder='Enter 16-20 character UMRN (e.g. CLIM7002012400012345)'
        />
      )}

      <InputDateUI
        context={context}
        name='stageDate'
        label={isRegister ? 'Registration Date' : 'Cancellation Date'}
        required
        selectedDateISO={date}
        onChange={(d) => onDateChange(d)}
      />
    </ModalFormUI>
  )
}

export default NACHStageModalUI
